import { headers } from '@/util/requests'

import { RecordFetcherParams } from '@/hooks/useFetchRecords'

export const fetchNotifications = async (
  csrfToken: RecordFetcherParams['csrfToken']
) => {
  const response = await fetch(`/user_notifications`, {
    headers: headers(csrfToken)
  })

  if (!response.ok) {
    const errorText = await response.text()
    return {
      notifications: [],
      error: `Failed to fetch notifications: ${errorText}`
    }
  }

  const { records } = await response.json()

  return {
    notifications: records,
    error: null
  }
}

export const markNotificationsAsRead = async (
  csrfToken: RecordFetcherParams['csrfToken']
) => {
  const response = await fetch(`/user_notifications/mark_all_as_read`, {
    method: 'POST',
    headers: headers(csrfToken)
  })

  if (!response.ok) {
    const errorText = await response.text()
    return {
      success: false,
      error: `Failed to mark notifications as read: ${errorText}`
    }
  }

  return {
    success: true,
    error: null
  }
}
